export function decode(str) {
  return str.replace(/&#(\d+);/g, (match, dec) => String.fromCharCode(dec))
}

export function zeroPad(num, size) {
  return `000${num}`.slice(size * -1)
}
